/**
 * @description 整个系统的全局配置状态管理，请勿随意修改
 */
import { isJson } from '@/utils/validate'
import {
    foldSidebar,
//   collapse as _collapse,
  showProgressBar,
  title,
  layout,
  fixedHeader,
  showTheme,
  background
} from '@/config'

const defaultTheme = { showProgressBar, layout, showTheme, fixedHeader, background }

const getLocalStorage = (key) => {
  const value = localStorage.getItem(key)
  if (isJson(value)) {
    return JSON.parse(value)
  } else {
    return false
  }
}
const { collapse = foldSidebar  } = getLocalStorage('collapse')

const state = () => ({
  title,
  device: 'desktop',
  collapse,
    // collapse: collapse || _collapse,
  theme: getLocalStorage('theme') || { ...defaultTheme },
  extra: { first: '' },
})

const getters = {
  theme: (state) => state.theme,
  title: (state) => state.title,
  device: (state) => state.device,
  collapse: (state) => state.collapse,
  extra: (state) => state.extra,
}

const mutations = {
  openSideBar(state) {
    state.collapse = false
  },
  foldSideBar(state) {
    state.collapse = true
  },
  toggleDevice (state, device) {
    state.device = device
  },
  toggleCollapse(state) {
    state.collapse = !state.collapse
    localStorage.setItem('collapse', `{"collapse":${state.collapse}}`)
  },
  saveTheme(state) {
    localStorage.setItem('theme', JSON.stringify(state.theme))
  },
  resetTheme(state) {
    state.theme = { ...defaultTheme }
    localStorage.removeItem('theme')
  },
  updateTheme(state) {
    document.getElementsByTagName('body')[0].className = `bd-theme-${state.theme.themeName}`
    if (state.theme.background !== 'none') {
      document.getElementsByTagName('body')[0].classList.add(state.theme.background)
    }
  },
}

const actions = {
  openSideBar({ commit }) {
    commit('openSideBar')
  },
  foldSideBar({ commit }) {
    commit('foldSideBar')
  },
  toggleDevice ({ commit }, device) {
    commit('toggleDevice', device)
  },
  toggleCollapse({ commit }) {
    commit('toggleCollapse')
  },
  saveTheme({ commit }) {
    commit('saveTheme')
  },
  resetTheme({ commit }) {
    commit('resetTheme')
    commit('updateTheme')
  },
  updateTheme({ commit }) {
    commit('updateTheme')
  },
}

export default { state, getters, mutations, actions }
